import { t } from '@lingui/core/macro';
import { useIsMobile } from 'noddi-ui-web';
import { formatCurrencyAmount } from 'noddi-util';

import { bookingCategoryVariants } from '@components/BookingFlow/Mobile/salesItems/variants';
import { SalesItemBookingCategoryType } from '@navio/nsdk';
import { cn, NoddiIcon } from 'noddi-ui-common';

type ServiceItemProps = {
  serviceName: string;
  price?: number;
  type: SalesItemBookingCategoryType;
  discountedPrice?: number;
  hidePopular?: boolean;
};

const HighlightedSalesItem = ({ serviceName, price, type, discountedPrice, hidePopular }: ServiceItemProps) => {
  const isMobile = useIsMobile();
  const variant = bookingCategoryVariants(isMobile)[type];

  return (
    <div className='relative w-full'>
      {!hidePopular && (
        <div className='absolute -top-3 right-4 z-10 w-fit rounded-tl-3xl rounded-r-3xl bg-card-selected-background px-3 py-1 text-card-selected-foreground shadow-md'>
          {t`Popular`}
        </div>
      )}
      <div className={cn('relative flex w-full gap-2 overflow-hidden rounded-xl bg-white px-4 py-6 pt-5 shadow-xs')}>
        <img className={cn('absolute top-1/2 right-0 sm:top-6')} src={variant.backgroundImage} alt='' />

        <div className='flex min-w-8 justify-center'>
          <div className='relative top-1'>
            <NoddiIcon name={variant.iconName} />
          </div>
        </div>

        <div className='flex w-full flex-col gap-1'>
          <p className='text-2xl'>{serviceName}</p>
          <div className='flex gap-1'>
            {price && <p className='line-through'>{price}</p>}
            {discountedPrice && (
              <p className='text-successDark'>
                {formatCurrencyAmount({
                  money: { amount: discountedPrice },
                  decimals: 0
                })}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export { HighlightedSalesItem };
